import React, { useEffect, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const barGrow = keyframes`
  from { width: 0%; }
  to   { width: 100%; }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #1A1208;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  animation: ${({ $hiding }) =>
    $hiding
      ? css`${fadeOut} 0.7s cubic-bezier(0.4,0,0.2,1) forwards`
      : 'none'};
`;

const LogoWrap = styled.div`
  animation: ${fadeIn} 0.8s cubic-bezier(0.16,1,0.3,1) both;
  animation-delay: 0.1s;
  img {
    height: 120px;
    width: auto;
    object-fit: contain;
    filter: drop-shadow(0 0 24px rgba(192,112,32,0.35));
  }
`;

const BarTrack = styled.div`
  width: 200px;
  height: 2px;
  background: rgba(255,253,247,0.1);
  border-radius: 999px;
  overflow: hidden;
  animation: ${fadeIn} 0.6s ease both;
  animation-delay: 0.3s;
`;

const BarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    #7C3A00 0%,
    #C07020 40%,
    #FAF3E0 60%,
    #C07020 80%,
    #7C3A00 100%
  );
  background-size: 400px 100%;
  animation:
    ${barGrow} ${({ $duration }) => $duration}ms cubic-bezier(0.4,0,0.2,1) both,
    ${shimmer} 1.4s linear infinite;
`;

const Tagline = styled.p`
  font-family: 'Raleway', serif;
  font-size: 0.72rem;
  letter-spacing: 0.28em;
  color: rgba(255,253,247,0.45);
  animation: ${fadeIn} 0.6s ease both;
  animation-delay: 0.5s;
`;

export function SplashScreen({ onDone }) {
  const [hiding, setHiding] = useState(false);
  const duration = 1600;

  useEffect(() => {
    const t1 = setTimeout(() => setHiding(true), duration + 200);
    const t2 = setTimeout(() => onDone(), duration + 900);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone, duration]);

  return (
    <Overlay $hiding={hiding}>
      <LogoWrap>
        <img src="/images/logonew.png" alt="Hacienda Real" />
      </LogoWrap>
      <BarTrack>
        <BarFill $duration={duration} />
      </BarTrack>
      <Tagline>Tradición artesanal desde 1950</Tagline>
    </Overlay>
  );
}
